import { Partners } from '../models/partners.interfaces';
import { Partners4ItemsMocks, Partners9ItemsMocks } from './items';

export const Partners3Mocks: Partners = {
  title: 'Earn With Our Partners',
  action: {
    label: 'View All Partners',
    url: '/mypromos/eligible'
  },
  items: [],
  disabled: false,
  loaded: true,
  status: 'exist'
};
Partners3Mocks.items = Partners4ItemsMocks;

export const Partners4Mocks: Partners = {
  title: 'Earn With Our Partners',
  action: {
    label: 'View All Partners',
    url: '/mypromos/eligible'
  },
  items: [],
  disabled: false,
  loaded: true,
  status: 'exist'
};
Partners4Mocks.items = Partners4ItemsMocks;

export const Partners5Mocks: Partners = {
  title: 'Earn With Our Partners',
  action: {
    label: 'View All Partners',
    url: '/mypromos/eligible'
  },
  items: [],
  disabled: false,
  loaded: true,
  status: 'new'
};
Partners5Mocks.items = Partners9ItemsMocks;

export const Partners8Mocks: Partners = {
  title: 'Earn With Our Partners',
  action: {
    label: 'View All Partners',
    url: '/mypromos/eligible'
  },
  items: [],
  disabled: false,
  loaded: true,
  status: 'new'
};
Partners8Mocks.items = Partners9ItemsMocks;

export const Partners9Mocks: Partners = {
  title: 'Earn With Our Partners',
  action: {
    label: 'View All Partners',
    url: '/mypromos/eligible'
  },
  items: [],
  disabled: false,
  loaded: true,
  status: 'new'
};
Partners9Mocks.items = Partners9ItemsMocks;
